import Vue from 'vue'
import Router from 'vue-router'

// 热橙健康
import venue_goods from '@/views/demo1/vgood'
import venue_goods_list from '@/views/demo1/list'
import venue_goods_list2 from '@/views/demo1/list2'
import venue_goods_detail from '@/views/demo1/detail'
import venue_goods_createorder from '@/views/demo1/createorder'
import venue_goods_createorder2 from '@/views/demo1/createorder2'
import venue_goods_order from '@/views/demo1/order'

import login from '@/views/demo1/login'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [{
			path: '/',
			name: 'venue_goods',
			component: venue_goods,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '酒店列表'
			}
		}, {
			path: '/venue_goods_list/:class_id',
			name: 'venue_goods_list',
			component: venue_goods_list,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '酒店列表'
			}
		}, {
			path: '/venue_goods_list2/:class_id',
			name: 'venue_goods_list2',
			component: venue_goods_list2,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '酒店列表'
			}
		}, {
			path: '/venue_goods_detail/:goodsId/:index',
			name: 'venue_goods_detail',
			component: venue_goods_detail,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '酒店详情'
			}
		}, {
			path: '/venue_goods_createorder/:goodsId/:date/:time',
			name: 'venue_goods_createorder',
			component: venue_goods_createorder,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '创建订单'
			}
		}, {
			path: '/venue_goods_createorder2/:course_timetable_id/:date/:time/:venue_name/:course_name',
			name: 'venue_goods_createorder2',
			component: venue_goods_createorder2,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '创建订单'
			}
		},{
			path: '/venue_goods_order',
			name: 'venue_goods_order',
			component: venue_goods_order,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '订单'
			}
		},

		{
			path: '/login',
			name: 'login',
			component: login,
			meta: {
				keepAlive: false,
				requireAuth: false,
				title: '登录'
			}
		},
	]

})

router.beforeEach((to, from, next) => {
	localStorage.setItem('test','test')
	// 假设这里检查用户是否已登录
	var token = localStorage.getItem('token');
	// venue_goods
	if (to.name !== 'login' && to.name !== 'venue_goods' && !token) {
		// 如果用户未登录且访问的不是登录页面，则跳转到登录页面
		next({
			name: 'login'
		});
	} else {
		// 否则继续正常导航
		next();
	}

})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js